import { useMemo } from 'react';
import { IProductInsideCombo } from 'src/types/combo';
import { IProductSize, PRODUCT_TYPE } from 'src/types/products';
import { getTranslate } from 'src/utils/formatter';
import { mealItemKey } from 'src/utils/helpers';
import { getProductUnits } from 'src/utils/product';
import { Carousel } from 'src/view/components/Carousel/Carousel';
import { ICurrentMealGroup } from '../../containers/MealComboItemsBlock/MealComboItemsBlock';
import ComboItem from '../ComboItem/ComboItem';
import ComboCarouselArrow from '../ComboCarouselArrow/ComboCarouselArrow';

interface IProps {
  index?: number;
  group: ICurrentMealGroup;
  comboSize?: IProductSize | null;
  selectItem: (item: IProductInsideCombo) => void;
}

const MealComboGroup: React.FC<IProps> = (props: IProps): JSX.Element => {
  const selectedItem: IProductInsideCombo | undefined = props.group.items.find((item) => item.is_selected);

  const units = useMemo(() => getProductUnits(selectedItem), [selectedItem]);

  const selectedItemDescription: string = [...units, getTranslate(selectedItem?.description)]
    .filter(Boolean)
    .join(' • ');

  return (
    <div className={`meal-items-group d-flex flex-column ${props.index ? 'pxmt-10' : ''}`}>
      <p className="family-semibold color-dark text-size-20 font-weight-600 mb-4">{getTranslate(props.group.name)}</p>
      <Carousel
        itemsToShow={3}
        itemsToScroll={2}
        renderArrow={ComboCarouselArrow}
        className="combo-items__carousel"
        disableArrowsOnEnd={true}
        focusOnSelect={true}
      >
        {props.group.items.map((item, index) => (
          <ComboItem
            key={mealItemKey(item, index)}
            index={index}
            item={item}
            selectItem={props.selectItem}
            className="combo-items__item"
            type={PRODUCT_TYPE.MEAL_COMBO}
          />
        ))}
      </Carousel>
      {selectedItemDescription ? (
        <p className="family-regular color-dark text-size-14 letter-spacing-5 text-lite-elipsis pxmt-4">
          {selectedItemDescription}
        </p>
      ) : null}
    </div>
  );
};

export default MealComboGroup;
